<template>
  <div
    class="master-container"
    :class="{ 'full-page': fullPage, 'standalone-page': isStandalonePage }"
  >
    <section
      v-for="container in containers"
      class="section-container"
      :style="determineBackground(container.background)"
      :class="container.class"
    >
      <section
        v-if="container.background"
        class="section-container"
        :class="{ 'faded-row': container.fadedRow }"
      >
        <v-img
          v-for="accent in container.accents"
          :class="accent"
          :src="determineSrc(accent)"
          contain
          v-if="displayAccents"
        />
        <section
          v-if="isHeader(container.name) || isFooter(container.name)"
          class="section-container"
        >
          <slot :name="container.name"></slot>
        </section>
        <section v-else class="content-container">
          <slot :name="container.name"></slot>
          <HR v-if="container.hr" :noHrPadding="container.noHrPadding" />
        </section>
      </section>
      <section v-else class="content-container">
        <slot :name="container.name"></slot>
        <HR v-if="container.hr" :noHrPadding="noHrPadding" />
      </section>
    </section>
  </div>
</template>
<script>
import HR from "../HR.vue";
export default {
  name: "Layout",
  components: {
    HR,
  },
  data() {
    return {
      countryPattern: require("@/assets/shared/redesign/backgrounds/country-pattern.svg"),
      tribalPattern: require(`@/assets/old_mutual/homepage/generic.svg`),
      greenAccentOne: require("@/assets/shared/redesign/backgrounds/green-accent-1.svg"),
      greenAccentTwo: require("@/assets/shared/redesign/backgrounds/green-accent-2.svg"),
      purpleAccent: require("@/assets/shared/redesign/backgrounds/purple-accent.svg"),
    };
  },
  props: {
    containers: {
      required: true,
      default: [],
      type: Array,
    },
    displayAccents: {
      required: false,
      default: true,
      type: Boolean,
    },
    fullPage: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  methods: {
    quickStartCardLinkClicked(routeName) {
      this.$router.push({ name: routeName });
    },
    determineBackground(background) {
      switch (background) {
        case "countryPattern":
          return this.countryPatternStyle;
        case "tribalPattern":
          return this.tribalPatternStyle;
        default:
          return {};
      }
    },
    isHeader(name) {
      return name === "header";
    },
    isFooter(name) {
      return name === "footer";
    },
    determineSrc(accent) {
      if (this.isMobile) {
        return "";
      }
      switch (accent) {
        case "green-accent-1":
          return this.greenAccentOne;
        case "green-accent-2":
          return this.greenAccentTwo;
        case "purple-accent-1":
          return this.purpleAccent;
        default:
          return "";
      }
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    isStandalonePage() {
      return this.$route.name === "AdviserEnrolment";
    },
    tribalPatternStyle() {
      return {
        backgroundImage: `url(${this.tribalPattern})`,
        backgroundSize: "cover",
        backgroundColor: "#F9F9F9",
        zIndex: "12",
      };
    },
    countryPatternStyle() {
      return {
        backgroundImage: `url(${this.countryPattern})`,
        backgroundSize: "100%",
      };
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.master-container {
  display: flex;
  flex-direction: column;
  width: 100dvw;
  align-items: center;
  background-color: #f9f9fb;
  padding-bottom: 88px;

  &.standalone-page {
    padding-bottom: 0;
    position: relative;
    min-height: 100vh;
  }

  .section-container {
    display: flex;
    flex-direction: column;
    width: 100dvw;
    align-items: center;
    position: relative;
  }

  .content-container {
    width: clamp(300px, 95dvw, 1600px);
    z-index: 12;
  }
  .faded-row {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(249, 249, 249, 0.2) 0%,
      rgba(249, 249, 249, 0.4) 30%,
      rgba(249, 249, 249, 0.8) 60%,
      rgba(249, 249, 249, 1) 100%
    );
    z-index: 12;
  }
}
.section-padding {
  padding-top: 88px;
  // padding-top: 5dvh;
}
.section-margin {
  margin-top: 40px;
}

.green-accent-1 {
  position: absolute;
  bottom: -140px;
  width: 150px;
  left: 0;
}
.green-accent-2 {
  position: absolute;
  width: 320px;
  top: -160px;
  left: 0px;
}
.purple-accent-1 {
  position: absolute;
  top: -315px;
  width: 200px;
  right: 0;
}

.tabbed-content,
.our-solutions {
  .green-accent-1 {
    position: absolute;
    top: 200px !important;
    width: 150px !important;
    left: -55px !important;
    bottom: unset !important;
  }
  .purple-accent-1 {
    top: 0;
    width: 200px;
    right: -60px;
  }
}

.how-it-works {
  .purple-accent-1 {
    top: -112px;
    width: 200px;
    right: -60px;
  }
}
.further-questions {
  .green-accent-2 {
    bottom: -452px;
    left: -141px;
  }
}

.faqs {
  .green-accent-1 {
    position: absolute;
    top: unset !important;
    width: 150px !important;
    bottom: 333px !important;
    left: -50px !important;
  }
  .purple-accent-1 {
    top: unset !important;
    width: 300px !important;
    right: 0 !important;
    bottom: -408.1px !important;
  }
}

.calculator {
  .green-accent-1 {
    position: absolute;
    bottom: unset !important;
    width: 150px !important;
    left: 0 !important;
    top: 50px !important;
  }
}
.adviser-enrolment {
  .green-accent-2 {
    position: absolute;
    width: 150px;
    top: -31px;
    left: 0px;
  }
  .purple-accent-1 {
    position: absolute;
    top: -104px;
    width: 150px;
    right: 0;
  }
}
.hero-banner {
  height: 540px;
  max-height: 540px;
  &.footer {
    margin-top: auto;
  }
}

.page-not-found {
  height: 80vh;

  .faded-row {
    height: inherit;
  }
}

@media screen and (min-height: 1060px) {
  .master-container {
    &.full-page {
      height: calc(100dvh - 224px);
    }
  }
}


</style>
